export default __webpack_public_path__ + "static/media/gallery-wip-handle_03.157c4d70.jpg";